/**
 * Theme infrastructure. Colors live in CSS custom properties (`styles/tokens.css`) and are
 * switched through `<html data-theme="...">`; this module only owns the names.
 *
 * Light is the default: the application is meant for classrooms and smart boards where bright,
 * high-contrast output stays readable (Phase 1 §18).
 */
export const THEMES = ['light', 'dark'] as const;
export type ThemeName = (typeof THEMES)[number];
export const DEFAULT_THEME: ThemeName = 'light';

export const isThemeName = (value: unknown): value is ThemeName =>
  typeof value === 'string' && (THEMES as readonly string[]).includes(value);
